// Types
import * as Types from '../types';

const makeNavigationItems = (items: Types.InternalLinkNavItem[]) => {
  return items.reduce(
    (
      acc: Types.InternalLinkNavItem[],
      item: Types.InternalLinkNavItem,
    ): Types.InternalLinkNavItem[] => {
      acc.push(item);

      // Filter Children
      if (item.children) {
        item.children = makeNavigationItems([...item.children]);
      }

      return acc;
    },
    [],
  );
};

export default makeNavigationItems;
